module.exports = __webpack_public_path__ + "img/mars.b76fe4f6.png";